import { createContext, useContext } from 'react';
import { useMultiSelectState } from './useMultiSelectState';

// Context typing provided by useMultiSelectContext so that it can be generic.
export const MultiSelectContext = createContext<unknown>(null);

// React context to track an individual multiselect's state
export function useMultiSelectContext<T>(): ReturnType<typeof useMultiSelectState<T>> {
  const context = useContext(MultiSelectContext) as ReturnType<
    typeof useMultiSelectState<T>
  > | null;
  if (!context) {
    throw new Error('useMultiSelectContext must be used within a MultiSelectContext.Provider');
  }
  return context;
}
